// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lz6M5YUzVVYiyQeUTh6m{padding:24px 15px}.QCnKxJE_wdurTvgUDZbI{justify-content:center;align-items:center;display:flex}.DZ79RAyLcEk47KE7QGlS{margin-bottom:28px}.DZ79RAyLcEk47KE7QGlS:last-of-type{margin-bottom:0}.i8buTavwtuMl27ep1gSa{margin-bottom:12px}.kABdmF410G27TQaBaVXA{padding-left:25px;list-style-type:disc}.gDU9dqDmcg1xa2RkqKd7{margin-left:-4px}.AM9yQrdWfGYz69q4iolA{align-items:center;gap:4px;padding-left:8px;padding-right:4px;display:flex;position:absolute;top:0;bottom:0;right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `lz6M5YUzVVYiyQeUTh6m`,
	"wrap--center": `QCnKxJE_wdurTvgUDZbI`,
	"wrapCenter": `QCnKxJE_wdurTvgUDZbI`,
	"group": `DZ79RAyLcEk47KE7QGlS`,
	"group__title": `i8buTavwtuMl27ep1gSa`,
	"groupTitle": `i8buTavwtuMl27ep1gSa`,
	"group__items": `kABdmF410G27TQaBaVXA`,
	"groupItems": `kABdmF410G27TQaBaVXA`,
	"group__item": `gDU9dqDmcg1xa2RkqKd7`,
	"groupItem": `gDU9dqDmcg1xa2RkqKd7`,
	"actions": `AM9yQrdWfGYz69q4iolA`
};
export default ___CSS_LOADER_EXPORT___;
